import React from "react";

const programs = [
  { title: "Weekly Friday Prayers (Jumu’ah)", image: "/programs/FridayPrayer.png" },
  { title: "Educational Programs for Youth", image: "/programs/lectures.png" },
  { title: "Community Events & Lectures", image: "/programs/education.png" },
  { title: "Qur’an Recitations & Competitions", image: "/programs/quran.png" },
  { title: "Eid Prayers and Gatherings", image: "/programs/eidPrayers.png" },
];

function Home() {
  return (
    <div style={styles.page}>
      {/* Header */}
      <header style={styles.header}>
        <h1 style={styles.title}>Welcome to Abo Ther Al-Ghafari Mosque</h1>
        <p style={styles.subtitle}>
          Serving Ottawa’s Shia Muslim community since <strong>1998</strong>
        </p>
      </header>

      {/* Intro Section */}
      <section style={styles.section}>
        <p style={styles.intro}>
          Established in 1998, Abu Ther Al-Ghafari Mosque has been a
          spiritual and cultural center for Ottawa’s Shia Muslim community. Guided by
          the Shia Muslim Scholars of North America, the mosque
          fosters faith, education, and unity across all generations.
        </p>
      </section>

      {/* Programs Section */}

      {/* Programs Section */}
      <div style={{ margin: "0 -25px" }}>
        <section style={styles.card}>
          <h2 style={styles.sectionTitle}>Our Programs & Activities</h2>
          <div style={styles.programGrid}>
            {programs.map((program) => (
              <div key={program.title} style={styles.programCard} className="program-card">
                <img src={program.image} alt={program.title} style={styles.programImage} />
              </div>
            ))}
          </div>
        </section>
      </div>



      {/* Social Media Section */}
       {/*
      <section style={styles.card}>
        <h2 style={styles.sectionTitle}>Follow Us on Social Media</h2>
        <div style={styles.socialLinks}>
          {[
            { href: "https://www.facebook.com/AbuTharAlGhafariMosque?mibextid=ZbWKwL", icon: "/facebookLogo.png", label: "Facebook" },
            { href: "https://www.instagram.com/abotheralghafarimosque?igshid=MzNlNGNkZWQ4Mg%3D%3D", icon: "/instagramLogo.png", label: "Instagram" },
            { href: "https://www.tiktok.com/@abotheralghafarim?_t=ZM-8szVHQuXbIT&_r=1", icon: "/tiktokLogo.png", label: "TikTok" },
            { href: "https://www.youtube.com/@abotheral-ghafarimosque3534", icon: "/youtubeLogo.png", label: "YouTube" },
            { href: "https://chat.whatsapp.com/FBCQzobDoWBFOpfDwEBQvV", icon: "/whatsappLogo.png", label: "WhatsApp" },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noreferrer"
              style={styles.socialBtn}
            >
              <img src={link.icon} alt={link.label} style={styles.icon} />
              {link.label}
            </a>
          ))}
        </div>
      </section>
      /*}


      {/* Hover Animation */}
      <style>{`
        .program-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .program-card:hover {
          transform: scale(1.07);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </div>
  );
}

const styles = {
  page: {
    backgroundColor: "#fff",
    fontFamily: "Georgia, serif",
    color: "#333",
    padding: "0px 25px",
    maxWidth: "1000px",
    margin: "0 auto",
    
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
  },
  title: {
    color: "#067446",
    fontSize: "2.5rem",
    marginBottom: "10px",
    fontWeight: "400", 
  },
  subtitle: {
    color: "#d19f14",
    fontSize: "1.1rem",
  },
  section: {
    textAlign: "center",
    marginBottom: "0px",
  },
  intro: {
    fontSize: "1.1rem",
    lineHeight: "1.8",
    maxWidth: "850px",
    margin: "0 auto",
    color: "#444",
  },
  card: {
    backgroundColor: "#f9f9f9",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
  },
  sectionTitle: {
    color: "#067446",
    borderBottom: "3px solid #d19f14",
    textAlign: "center",
    marginBottom: "25px",
    paddingBottom: "6px",
    fontSize: "1.7rem",
    fontWeight: "400", 

  },
  socialLinks: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "15px",
  },
  socialBtn: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    textDecoration: "none",
    backgroundColor: "#fff",
    color: "#333",
    padding: "10px 18px",
    borderRadius: "10px",
    transition: "0.3s ease",
  },
  icon: {
    width: "22px",
    height: "22px",
  },
  programGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "18px",
  },
  programCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    textAlign: "center",
    width: "150px",
    height: "150px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  programImage: {
    width: "90%",
    height: "90%",
    objectFit: "contain",
    borderRadius: "8px",
  },
};

export default Home;
